import { render } from "./vhpSimpleSlide.vue?vue&type=template&id=21374b64&scoped=true"
import script from "./vhpSimpleSlide.vue?vue&type=script&lang=js"
export * from "./vhpSimpleSlide.vue?vue&type=script&lang=js"

import "./vhpSimpleSlide.scss?vue&type=style&index=0&id=21374b64&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21374b64"]])

export default __exports__